import * as React from "react";
import { connect } from "react-redux";

import {
  ScreenProps,
  ScreenWrapped as ScreenComponent,
} from "../../components/Screen/Screen";
import { setScreenName } from "../../actions";
import { withAction } from "../Actions/withActions";

class Screen extends React.Component<ScreenProps> {
  render() {
    return <ScreenComponent {...this.props} />;
  }
}

export default withAction(connect(null, { setScreenName })(Screen));
